// extracted by mini-css-extract-plugin
export var askAiIcon = "_os-9";
export var container = "_os-0";
export var groupSeparator = "_os-a";
export var highlight = "_os-4";
export var resultIcon = "_os-5";
export var resultItem = "_os-7";
export var resultSubtitle = "_os-3";
export var resultTitle = "_os-2";
export var resultsList = "_os-1";
export var searchGroup = "_os-6";
export var selected = "_os-8";